import { getSupplierMaterials } from "../api/services.ts"

const MATERIALS_PER_REQUEST = 200

type MaterialListResponse = Awaited<ReturnType<typeof getSupplierMaterials>>

/**
 * The supplier's whole price list, however many pages the server splits it
 * into. The paste preview has to say which pasted names already exist, and a
 * name on page three is still an update — one page would understate the count
 * and promise a creation the import would not perform.
 */
export const listEverySupplierMaterial = async (
  supplier: string
): Promise<MaterialListResponse> => {
  const pageOf = (page: number) =>
    getSupplierMaterials({ supplier, page, page_size: MATERIALS_PER_REQUEST })

  const first = await pageOf(1)
  if (!first.ok || !first.data) return first

  const results = [...first.data.results]
  let { next } = first.data
  for (let page = 2; next; page++) {
    const response = await pageOf(page)
    if (!response.ok || !response.data) return response
    results.push(...response.data.results)
    next = response.data.next
  }
  return { ...first, data: { ...first.data, results, next: null } }
}
